import React from "react"

import {FieldViewProps} from "../../../../render/view"
import FieldGoalType_DropdownValue from "../components/dropdown-value"

export default function FieldGoalType_GoalListView(props: FieldViewProps) {

    const option = props.field._getOption(props.model[props.field.fieldId])

    return <FieldGoalType_DropdownValue className={props.className} option={option} field={props.field}/>

}
